export default {
	id: 'overview',
	name: 'Overview Dashboard',
	description: 'A dashboard overview',
	items: [
		{
			widget: 'timeSeriesRevenueVsGrossProfit',
			position: { w: 24, h: 9, x: 0, y: 0 },
		},

		{
			widget: 'averageTransactionValue',
			position: { w: 6, h: 5, x: 0, y: 9 },
		},
		{
			widget: 'averageUnitsPerTransaction',
			position: { w: 6, h: 5, x: 6, y: 9 },
		},

		{
			widget: 'totalTransactions',
			position: { w: 6, h: 5, x: 12, y: 9 },
		},
		{
			widget: 'customTotalRevenue',
			position: { w: 6, h: 5, x: 18, y: 9 },
		},

		{
			widget: 'hourOfDayPerformance',
			position: { w: 12, h: 9, x: 0, y: 14 },
		},
		{
			widget: 'dayOfWeekPerformance',
			position: { w: 12, h: 9, x: 12, y: 14 },
		},
		{
			widget: 'saleTypeBreakdown',
			position: { w: 12, h: 9, x: 0, y: 23 },
		},
		{
			widget: 'recentSales',
			position: { w: 12, h: 9, x: 12, y: 23 },
		},
	],
};
